
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/utils";

interface ChildBalanceCardProps {
  balance: number;
}

export function ChildBalanceCard({ balance }: ChildBalanceCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Current Balance</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-3xl font-bold">{formatCurrency(balance)}</p>
      </CardContent>
    </Card>
  );
}
